import { engine } from "@shared/module-transformers/engine.ts";

export const useEngine = () => {
  return {
    engine,
  };
};
